import { useEffect, useState } from "react";

export interface IBeforeInstallPromptEvent extends Event {
  readonly platforms: string[];
  readonly userChoice: Promise<{
    outcome: "accepted" | "dismissed";
    platform: string;
  }>;
  prompt(): Promise<void>;
}

function useAddToHomescreenPrompt(): [
  IBeforeInstallPromptEvent | null,
  () => void,
  boolean
] {
  const [prompt, setState] = useState<IBeforeInstallPromptEvent | null>(null);
  const [installed, setInstalled] = useState<boolean>(false);

  const promptToInstall = async () => {
    if (prompt) {
      prompt.prompt();

      const { outcome } = await prompt.userChoice;

      if (outcome === "accepted") {
        console.log("User accepted the install prompt.");
        setState(null);
      } else if (outcome === "dismissed") {
        console.log("User dismissed the install prompt");
      }

      return setInstalled(false);
    }
    console.error(
      "'Tried installing before browser sent beforeinstallprompt event'"
    );
  };

  useEffect(() => {
    const ready = (e: IBeforeInstallPromptEvent) => {
      e.preventDefault();
      setState(e);
    };
    const appInstalled = () => {
      setInstalled(true);
      console.log("PWA was installed");
    };

    window.addEventListener("appinstalled", appInstalled as any);
    window.addEventListener("beforeinstallprompt", ready as any);

    return () => {
      window.removeEventListener("beforeinstallprompt", ready as any);
      window.removeEventListener("appinstalled", appInstalled as any);
    };
  }, []);

  return [prompt, promptToInstall, installed];
}

export default useAddToHomescreenPrompt;
